import React from "react";
import { FaStethoscope, FaNotesMedical, FaMedkit, FaClinicMedical, FaUsersCog, FaUserClock, FaBook, FaCog, FaKey  } from "react-icons/fa";
import { useAuth } from "../../context/auth";
import SidebarItem from "./sidebaritems";
import SidebarExpandableItem from "./sidebaritems/SidebarExpandableItem";
import './sidebar.scss';

const Sidebar = () => {
  const {user, logout} = useAuth();
  const links = [
    {
      icon: FaStethoscope,
      text: "Patients",
      path: '/patients',
    },
    {
      icon: FaNotesMedical,
      text: "Prescriptions",
      path: '/prescriptions',
    },
    {
      icon: FaMedkit,
      text: "MD Integrations",
      path: '/md-integrations',
    },
    {
      icon: FaClinicMedical,
      text: "Hallandale",
      path: '/hallandale',
    },
    {
      icon: FaUserClock,
      text: "Prospects",
      path: '/prospects',
    },
    {
      icon: FaBook,
      text: "Reports",
      path: '/reports',
    },
    {
      icon: FaUsersCog,
    	text: "Users",
      path: '/users',
      isHidden: user?.role !== "admin",
    }
  ];

  const settingsSubItems = [
    {
      icon: FaKey,
      text: "Change Password",
      path: '/settings/change-password',
    }
  ];


  return (
    <div className="component_sidebar">
      <div className="sidebar_logo">
        <img src="/img/whitebm.png" height={100} width={240} alt="Body Miracle" />
      </div>
      <nav className="sidebar_nav">
        {links.map((link, i) => {
          if(!link.isHidden) {
            return <SidebarItem Icon={link.icon} key={i} text={link.text} path={link.path} />;
          }
          return null;
        })}
        <SidebarExpandableItem
          Icon={FaCog}
          text="Settings"
          subItems={settingsSubItems}
        />
      </nav>
      <div className="sidebar_footer">
        <div className="sidebar_logout" onClick={logout}>Log out</div>
      </div>
    </div>
  );
};

export default Sidebar;